import { GET_SELECT_FACILITY_SUCCESS } from "../actions/servicesAction"


const selectedFacilityReducer = (state = {}, { type,  payload={} }) => {
    switch (type) {
      case GET_SELECT_FACILITY_SUCCESS:
        return payload
      default:
        return state
    }
  }
  
  export default selectedFacilityReducer